const faqItems = [
  {
    id: 1,
    question: '蓝莓影院是否需要注册或付费？',
    answer: '完全不需要！蓝莓影院所有电视剧均可免费在线观看，无需注册账号，无需充值会员，打开网页即可畅享海量电视剧全集。',
  },
  {
    id: 2,
    question: '播放电视剧会卡顿缓冲吗？',
    answer: '蓝莓影院采用智能CDN分发技术，支持1080P高清画质，自动适配您的网络环境。正常情况下播放流畅不缓冲，即使网速一般也能获得良好的观看体验。',
  },
  {
    id: 3,
    question: '剧集更新速度如何？',
    answer: '热门电视剧每日同步更新，新剧上线后第一时间更新到最新集数。您可以关注首页更新动态板块，随时掌握最新剧集上线信息。',
  },
  {
    id: 4,
    question: '可以在手机上观看吗？',
    answer: '当然可以！蓝莓影院全面适配手机、平板和电脑等设备。您可以通过手机浏览器直接访问，无需下载APP，随时随地追剧。',
  },
  {
    id: 5,
    question: '收录了哪些类型的电视剧？',
    answer: '蓝莓影院收录了古装、都市、悬疑、爱情、年代、喜剧、军旅、奇幻等各类型电视剧两万余部，涵盖热播新剧与经典老剧，满足不同观众的追剧需求。',
  },
  {
    id: 6,
    question: '经典老剧可以找到吗？',
    answer: '可以！蓝莓影院收录了大量经典老剧全集，包括上世纪八九十年代的电视剧作品。在剧集索引中选择年代分类，即可发现那些值得重温的经典之作。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于蓝莓影院的常见疑问，这里都有解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q</span>
                <span>{item.question}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}